import axios from "axios";
import links from './../../consts/links'

export default ({dispatch, next, action}) => {
    const {type} = action;

    const tieringAxios = () => {
        return window.auth.refreshSso({audience: "https://cloudmanager.cloud.netapp.com"})
            .then(({accessToken}) => {
                return axios.create({
                    baseURL: links.demos.cloudTiering,
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    }
                });
            })
    };

    if (type === "DEMO:RESET_CLOUD_TIERING") {
        dispatch({type: "DEMO:RESET_CLOUD_TIERING_PENDING"});
        tieringAxios()
            .then(instance => instance.put('/api/reset-simulator'))
            .then(() => dispatch({type: "DEMO:RESET_CLOUD_TIERING_SUCCESS"}))
            .catch(err => dispatch({type: "DEMO:RESET_CLOUD_TIERING_ERROR", payload: {err}}));
    }
    return next(action);
};